<template>
  <div class="lv-batch-add-member-card">
    <div class="lv-batch-add-member-card_content">
      <div class="lv-batch-add-member-card_content-btn">
        <WsRow>
          <WsCol cols="3" smcols="12">
            <WsButton001
              outLine
              @click="$_onDownloadExample"
            >
              {{ $t('下載{file}範本',{file:'xlsx'}) }}
            </WsButton001>
          </WsCol>
          <WsCol cols="3" smcols="12">
            <WsButton001
              outLine
              @click="$_handleUploadBtnClick"
            >
              {{ $t('匯入{file}檔案',{file:'xlsx'}) }}
            </WsButton001>
          </WsCol>
        </WsRow>
        <input
          ref="fileInput"
          class="input"
          type="file"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          @change="$_onChange($event)"
        >
      </div>
    </div>
    <div
      v-if="batchMemberList.length && !isLoading.import && !isLoading.submit"
      class="lv-batch-add-member-card_result-chip green"
    >
      <WsTextChip001
        leading-icon="icon-warning-filled"
        :text-label="`${$t('匯入成功')}：${$t('請確認以下資料是否正確，若資料有誤請妥善編輯或重新匯入檔案。')}`"
        green
        thin
        font-size-sm
        icon-xl
      />
    </div>
    <div
      v-if="error"
      class="lv-batch-add-member-card_result-chip"
    >
      <WsTextChip001
        leading-icon="icon-warning-filled"
        :text-label="`${$t('匯入失敗')}：${$t('檔案格式有誤，請確認是否依照{file}範本填入資料，不可更動範本欄位。',{file:'xls'})}`"
        red
        thin
        font-size-sm
        icon-xl
      />
    </div>
    <NormalSkeleton v-if="isLoading.import || isLoading.submit"/>
    <LvStateMemberInputList
      v-if="batchMemberList.length && !isLoading.import && !isLoading.submit"
      :input-list="batchMemberList"
      @submit="$_onSubmit($event)"
      @cancel="$_onResetMemberList()"
    />
    <PopUp
      :pop-up-active="isActive[_popup.value]"
      :title="$t(_popup.items[_popup.value].title)"
      @click="$_onClosePopup(_popup.value)"
    >
      <WsText001
        v-for="(email, emailIndex) in sameEmail"
        :key="emailIndex"
        class="mt-10"
      >
        {{email}}
      </WsText001>
      <LlCancelPopupContent :cancel-text="_popup.items[_popup.value].cancelText">
        <template v-slot:buttons>
          <WsButton001
            @click="$_onClosePopup(_popup.value)"
          >
            {{ $t('確定') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
  </div>
</template>
<script>
import S_file from "@/service/api/v1/file";
import S_user from "@/service/api/v1/user";

export default {
  name: "LvBatchAddMemberCard",
  props: {
    maxMemberCount: {
      type: Number,
    },
    memberCount: {
      type: Number,
    },
  },
  data() {
    return {
      isLoading: {
        import: false,
        submit: false,
      },
      isActive: {
        successPopup: false,
        sameEmailPopup: false,
        fullPopup: false,
      },
      error: false,
      batchMemberList: [],
      sameEmail: [],
    }
  },
  computed: {
    _availableMemberCount() {
      return this.maxMemberCount - this.memberCount;
    },
    _popup() {
      const popup = {
        value: "successPopup",
        items: {
          successPopup: {
            title: "已成功建立",
          },
          sameEmailPopup: {
            title: "以下Email在匯入檔案中重複出現，請修改匯入檔案之後，再次匯入。",
          },
          fullPopup: {
            title: "匯入人數超過可啟用帳號數量",
            cancelText: this.$t(`此單位剩餘成員帳號數量為{number}，已將匯入檔案中前{number}筆帳號匯入。`,{number: this._availableMemberCount}),
          },
        }
      }
      return popup;
    }
  },
  methods: {
    async $_onChange($event) {
      this.$_onResetMemberList();
      this.isLoading.import = true;
      const file = $event.target.files[0];
      const factoryId = this.$store.state.app.factory.id;
      const url = `factory/${factoryId}/import/user`;
      try {
        const res = await S_file.importFile(url, file);
        const rawData = res.data.data;
        this.sameEmail = this.$_getSameEmail(rawData);
        if (this.sameEmail.length) {
          this.$_onOpenPopup('sameEmailPopup');
        } else {
          const memberList = this.$_setMemberList(rawData);
          if (memberList.length > this._availableMemberCount) {
            this.$_onOpenPopup('fullPopup');
            this.batchMemberList = memberList.slice(0, this._availableMemberCount);
          } else {
            this.batchMemberList = memberList;
          }
        }
      } catch(error) {
        alert(error);
        this.error = true;
      } finally {
        this.isLoading.import = false;
      }
    },
    $_handleUploadBtnClick() {
      if (this.isLoading.submit || this.isLoading.import) return
      this.$refs.fileInput.click();
    },
    async $_onSubmit($event) {
      this.isLoading.submit = true;
      try {
        const data = {
          users: $event,
        }
        await S_user.batchUsersCreate(data);
        this.$_onResetMemberList();
        this.$_onOpenPopup('successPopup');
        this.$emit('batch-create-success');
      } catch (error) {
        alert(error);
      } finally {
        this.isLoading.submit = false;
      }
    },
    $_onOpenPopup(type) {
      this._popup.value = type;
      this.isActive[type] = true;
    },
    $_onClosePopup(type) {
      this.isActive[type] = false;
      if (type === "sameEmailPopup") {
        this.sameEmail = [];
      }
    },
    $_getSameEmail(memberList) {
      const allEmail = memberList.map(member => member.email);
      const sameEmail = [];
      allEmail.forEach(email => {
        if (email) {
          const tarEmail = allEmail.filter(_email => _email === email);
          const isInSameEmail = sameEmail.some(_email => _email === email);
          if (tarEmail.length > 1 && !isInSameEmail) {
            sameEmail.push(email);
          }
        }
      })
      return sameEmail;
    },
    $_setMemberList(rawData) {
      const memberList = [];
      rawData.forEach(data => {
        if (!data.name && !data.email) {
          return;
        } else {
          const {name, email} = data;
          memberList.push ({
            name,
            email: email ? email.trim() : "",
          });
        }
      });
      return memberList;
    },
    $_onResetMemberList() {
      this.batchMemberList = [];
    },
    $_onDownloadExample() {
      const fileUrl = `${process.env.BASE_URL}batch-add-member-example.xlsx`;
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = 'batch-add-member-example.xlsx';
      link.click();
    },
  },
};
</script>